module.exports = __webpack_public_path__ + "img/11招商加盟-img3_03.64138fcb.png";